import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../features/filter/filterSlice";
import { fetchTransactions } from "../../features/transaction/transactionSlice";
import Form from "../Form";
import Transaction from "./Transaction";

const AllTransacion = () => {
    const [type, setType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const dispatch = useDispatch();
    const { transactions, isLoading, isError, editing } = useSelector(
        (state) => state.transaction
    );

    // get the filter status
    const filterStatus = useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(fetchTransactions());
    }, [dispatch]);

    if (filterStatus) {
        console.log(filterStatus);
    }

    // decide what to render
    let content = null;
    if (isLoading) content = <p>Loading...</p>;

    if (!isLoading && isError)
        content = <p className="error">There was an error occured</p>;

    if (!isLoading && !isError && transactions?.length > 0) {
        content = transactions
            .filter((t) => {
                if (searchTerm !== "") {
                    const regex = new RegExp(`${searchTerm}`, "gi");
                    return t.name.match(regex);
                } else if (filterStatus.filter === "all") {
                    return t;
                } else if (t.type === filterStatus.filter) {
                    return t;
                } else {
                    return false;
                }
            })
            .map((transaction) => (
                <Transaction key={transaction.id} transaction={transaction} />
            ));
    }

    if (!isLoading && !isError && transactions?.length === 0) {
        content = <p>No transactions found!</p>;
    }

    if (type) {
        dispatch(setFilter(type));
    }

    return (
        <div className="container">
            {editing !== null && <Form>Edit Transaction</Form>}
            <p className="second_heading">Your All Transactions:</p>
            <div className="form-group radio">
                {/* <label>Filter</label> */}
                <div className="radio_group">
                    <input
                        required
                        type="radio"
                        value="income"
                        name="type"
                        checked={type === "income"}
                        onChange={(e) => setType("income")}
                    />
                    <label>Income</label>
                </div>
                <div className="radio_group">
                    <input
                        type="radio"
                        value="expense"
                        name="type"
                        placeholder="Expense"
                        checked={type === "expense"}
                        onChange={(e) => setType("expense")}
                    />
                    <label>Expense</label>
                </div>
                <div className="radio_group">
                    <input
                        type="radio"
                        value=""
                        name="type"
                        placeholder="Expense"
                        checked={type === "all"}
                        onChange={(e) => setType("all")}
                    />
                    <label>All</label>
                </div>
            </div>
            <input
                type="text"
                className="searchTerm"
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by task name"
            />
            <div className="conatiner_of_list_of_transactions">
                <ul>{content}</ul>
            </div>
        </div>
    );
};

export default AllTransacion;
